import { milestones } from '@/mocks/siteData';
import SectionHeading from '@/components/base/SectionHeading';

export default function MilestonesSection() {
  return (
    <section className="bg-foreground-950 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <SectionHeading
            kicker="Milestones"
            title="一路走来的几个节点"
            description="不是成绩单，而是我们做过的几个关键选择：从匿名收信到流程化保护信源，再到把方法开放给协作者与研究者。"
            tone="light"
          />

          <ol className="mt-12 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-10 gap-x-6">
            {milestones.map((item, index) => (
              <li key={item.year} className="relative">
                <div className="flex items-center gap-4">
                  <span className="font-heading text-3xl md:text-4xl font-black text-accent-500">
                    {item.year}
                  </span>
                  <span className="w-2.5 h-2.5 rounded-full bg-primary-500"></span>
                  {index < milestones.length - 1 ? (
                    <span className="hidden lg:block flex-1 border-t border-dashed border-background-50/20"></span>
                  ) : null}
                </div>
                <h3 className="mt-6 font-heading text-base md:text-lg font-bold text-background-50">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-background-300">{item.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}